// src/components/Admin/AdminSidebarNavigation.jsx - Con sezione Parco Veicoli
import React, { useState, useEffect } from 'react';
import './AdminSidebarNavigation.css';

const AdminSidebarNavigation = ({ currentSection, onSectionChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // AGGIORNATO: Aggiunta sezione Parco Veicoli
  const sections = [
    {
      id: 'personale',
      title: 'Gestione Personale',
      icon: '👥'
    },
    {
      id: 'cantieri',
      title: 'Gestione Cantieri',
      icon: '🏗️'
    },
    {
      id: 'parcoVeicoli',
      title: 'Parco Veicoli',
      icon: '🚗'
    },
    {
      id: 'calendario',
      title: 'Calendario',
      icon: '📅'
    }
  ];

  // Gestione responsive
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Gestione click fuori dalla sidebar (solo mobile)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobile && isOpen) {
        // Chiudi se si clicca fuori dalla sidebar e dal pulsante
        if (!event.target.closest('.simple-sidebar') && 
            !event.target.closest('.sidebar-arrow-btn')) {
          setIsOpen(false);
        }
      }
    };

    if (isMobile && isOpen) {
      document.addEventListener('click', handleClickOutside);
      // Previeni scroll del body quando sidebar è aperta su mobile
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = 'unset';
      document.body.style.position = 'unset';
      document.body.style.width = 'unset';
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.body.style.overflow = 'unset';
      document.body.style.position = 'unset';
      document.body.style.width = 'unset';
    };
  }, [isMobile, isOpen]);

  // Gestione tasto ESC per chiudere
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  const handleSectionClick = (sectionId) => {
    onSectionChange(sectionId);
    // Chiudi la sidebar dopo la selezione
    setIsOpen(false);
  };

  const toggleSidebar = (event) => {
    event.stopPropagation();
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className={`simple-sidebar ${isOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-content">
          {sections.map(section => (
            <button
              key={section.id}
              className={`sidebar-item ${currentSection === section.id ? 'active' : ''}`}
              onClick={() => handleSectionClick(section.id)}
              title={section.title}
            >
              <span className="sidebar-icon">{section.icon}</span>
              <span className="sidebar-label">{section.title}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Toggle button per mobile/desktop */}
      <button 
        className={`sidebar-arrow-btn ${isOpen ? 'open' : 'closed'}`}
        onClick={toggleSidebar}
        aria-label={isOpen ? 'Chiudi menu' : 'Apri menu'}
      >
        {isOpen ? '✕' : '☰'}
      </button>

      {/* Overlay per mobile quando sidebar è aperta */}
      {isMobile && isOpen && <div className="sidebar-overlay" />}
    </>
  );
};

export default AdminSidebarNavigation;